import React from 'react';
import {CButton} from '@coreui/react-pro';
import {
  isMobile,
  isMobileOnly,
} from 'react-device-detect';
import ReportsModal from './ReportsModal';
import {
  fetchTableauToken,
  userSelectedReport,
} from './reports-actions';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

const Reports = () => {

  const dispatch = useDispatch();

  const {
    sidebarVisible,
    sidebarUnfoldable,
  } = useSelector(state => state.userSettings);

  const tableauToken = useSelector(state => state.reports.tableauToken);

  const growerId = useSelector(state => state.auth.authorization.growerId);

  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  const [windowHeight, setWindowHeight] = React.useState(window.innerHeight);

  React.useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize)
  }, []);

  React.useEffect(() => {
    dispatch(fetchTableauToken());
  }, [dispatch]); 

  const height = windowHeight - 64;

  var width = windowWidth;

  if (sidebarUnfoldable === true && sidebarVisible === true) {
    width -= 64;
  }
  else if (sidebarUnfoldable === false && sidebarVisible === true) {
    width -= 256;
  }

  return (
    <>
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        padding: 0,}}>
        <div style={{
          display: 'flex',
          flexDirection: isMobile === true ? 'column' : 'row',
          paddingTop: isMobile === true ? 20 : 13,
          justifyContent: 'space-evenly',
          alignContent: 'center',
          alignItems: 'center'}}>
          {
            tableauToken !== null ? (
              <>

                {/* Customer Position KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96  : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20, 
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerPosition_16875322390090/CustomerPosition?:origin=card_share_link&:embed=n', 'Customer Position'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerPosition_16875322390090/OpenPosition-SplashScreen?:origin=card_share_link&:embed=n'
                    token={tableauToken}
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>
                
                {
                    isMobile === true ? (<><br/></>) : null
                }

                {/* Contract Reconciliation KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96  : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20,
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerContractibleGrainwithOpenPositions/ContractReconciliation?:origin=card_share_link&:embed=n', 'Contract Reconciliation'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerPosition_16875322390090/ContractReconciliation-SplashScreen?:origin=card_share_link&:embed=n'
                    token={tableauToken}
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>

                {
                    isMobile === true ? (<><br/></>) : null
                }

                {/* Delivery & Settlement KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96 : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20, 
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerSettlementsV1_0/SettlementReport?:origin=card_share_link&:embed=n', 'Settlement History'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/CustomerSettlementsV1_0/SplashScreen?:origin=card_share_link&:embed=n'
                    token={tableauToken}
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>

              </>
            ) : null
          }
        </div>
        <div style={{
          display: 'flex',
          flexDirection: isMobile === true ? 'column' : 'row',
          paddingTop: isMobile === true ? 20 : 13,
          justifyContent: 'space-evenly',
          alignContent: 'center',
          alignItems: 'center'}}>
          {
            tableauToken !== null ? (
              <>

                {/* Scale Turnaround KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96  : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20, 
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/ScaleTurnAround/ScaleTurnAroundTime?:origin=card_share_link&:embed=n', 'Scale Turnaround'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/ScaleTurnAround/ScaleTurnAroundSplashScreen?:origin=card_share_link&:embed=n'
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>
                
                {
                    isMobile === true ? (<><br/></>) : null
                }

                {/* Accured Drying KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96  : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20, 
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/AccruedDryingChargesV1_0/AccruedCharges?:origin=card_share_link&:embed=n', 'Accured Drying/Deductions'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/AccruedDryingChargesV1_0/SplashScreen?:origin=card_share_link&:embed=n'
                    token={tableauToken}
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>

                {
                    isMobile === true ? (<><br/></>) : null
                }

                {/* Accured Storage KPI report */}
                <CButton
                  style={{
                    width: isMobile === true ? width * 0.96  : width / 3 - 20, 
                    height: isMobile === true ? 500 : height / 2 - 20, 
                    backgroundColor: 'transparent', 
                    padding: 0, 
                    boxShadow: 'none', 
                    overflow: 'hidden', 
                    border: 1, 
                    borderColor: 'black', 
                    borderStyle: 'groove',}}
                  onClick={() => dispatch(userSelectedReport('https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/AccruedOS-PLV1_0/AccruedCharges?:origin=card_share_link&:embed=n', 'Open Service/Storage Charges'))}>
                  <tableau-viz 
                    style={{zIndex: -1, position: 'relative',}}
                    src='https://prod-useast-b.online.tableau.com/t/premiercooperativeinc/views/AccruedOS-PLV1_0/OS-PLSplashScreen?:origin=card_share_link&:embed=n'
                    token={tableauToken}
                    toolbar='hidden'
                    hide-tabs
                    device={isMobileOnly === true ? 'phone' : 'desktop'}
                    width={isMobile === true ? width * 0.96  : width / 3 - 20}
                    height={isMobile === true ? 500 : height / 2 - 20}>
                    <viz-parameter name='Customer ID Parameter' value={growerId}></viz-parameter>
                  </tableau-viz>
                </CButton>
                
                {
                    isMobile === true ? (<><br/></>) : null
                }

              </>
            ) : null
          }
        </div>
      </div>
      <ReportsModal />
    </>
  );
}

export default Reports;
